import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'common-libs';
import { UrlService } from './theme/shared/url.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  private previousUrl = '';
  private currentUrl  = '';
  private routerSub!: Subscription;

  constructor(
    private router: Router,
    private urlService: UrlService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // ✅ filter before subscribe — only NavigationEnd events enter the callback
    this.routerSub = this.router.events
      .pipe(filter(evt => evt instanceof NavigationEnd))
      .subscribe(evt => {
        window.scrollTo(0, 0);
        this.previousUrl = this.currentUrl;
        this.currentUrl  = (evt as NavigationEnd).url;
        this.urlService.setPreviousUrl(this.previousUrl, this.currentUrl);
      });

    this.authService.startAutoLogoutTimer();
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();  // ✅ prevents subscription leak
  }
}